<template>
  <div>
    <div class="form-wrap">
      <div class="px-2 content-header" style=""><trans-text i18nKey="ui[8][3]"/></div>
      <div class="form-list px-2 pt-2">
        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.family_name.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[8][4]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" v-model.trim="input.family_name" @change="$v.input.family_name.$touch()">

          </div>

          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.family_name" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_2'][1]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.given_name.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[8][5]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" v-model.trim="input.given_name" @change="$v.input.given_name.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.given_name" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_2'][2]"/></input-feedback>
          </p>

          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.address_1.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[8][6]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" v-model.trim="input.address_1" @change="$v.input.address_1.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.address_1" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_2'][3]"/></input-feedback>
          </p>

          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[8][7]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" v-model.trim="input.address_2" @change="$v.input.address_2.$touch()">
          </div>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.city.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[8][8]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" v-model.trim="input.city" @change="$v.input.city.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.city" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_2'][4]"/></input-feedback>
          </p>

          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.prefecture.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[8][9]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" v-model.trim="input.prefecture" @change="$v.input.prefecture.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.prefecture" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_2'][5]"/></input-feedback>
          </p>

          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.zip_code.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[8][10]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" v-model.trim="input.zip_code" @change="$v.input.zip_code.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.zip_code" type=""><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_2'][6]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.country_name.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[8][11]"/></label>
          <div class="col-7">
            <input  class="form-control transparent-input" type="text" v-model.trim="input.country_name" @change="$v.input.country_name.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.country_name" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_2'][8]"/></input-feedback>
          </p>

          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.phone_nunber.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[8][12]"/></label>
          <div class="col-7">
            <input  class="form-control transparent-input" type="text" v-model.trim="input.phone_nunber" @change="$v.input.phone_nunber.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.phone_nunber" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['10_2'][9]"/></input-feedback>
          </p>

          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.email.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[8][13]"/></label>
          <div class="col-7">
            <p class="form-control-static">{{input.email}}</p>
          </div>
        </div>

      </div>

      <div v-for="(cartEvent,index) of cartEvents">
        <!--<template v-if="child_info_input[index]">-->
        <div class="px-2 content-header" style=""><trans-text i18nKey="ui[8][14]" :replaceData="{scool_name:cartEvent.organization.name,event_name:cartEvent.name}"   /></div>

        <div class="form-list px-2 pt-2">

          <!-- 入力項目-->
          <div class="form-group row">

            <label class="col-12 col-form-label" v-for="childInfo of childInfos">
              <input class="" type="radio" :name="'childInfo['+index+']'" :value="childInfo.id" v-model="child_info_input[index].child_info_id" @click="applyChildInfo(childInfo,index,cartEvent)"> {{childInfo.family_name}} {{childInfo.given_name}}
            </label>

            <label class="col-12 col-form-label">
              <input class="" type="radio" :name="'childInfo['+index+']'" value="-1" v-model="child_info_input[index].child_info_id" @click="applyChildInfo({id:-1,family_relation_id:1},index,cartEvent)"> <trans-text i18nKey="ui[8][15]"/>
            </label>

            <div class="col-12 form-hr">
              <hr class="">
            </div>
          </div>

          <!-- 入力項目-->
          <div class="form-group row" :class="{'has-danger': $v.child_info_input.$each[index].family_name.$error}">
            <label class="col-5 col-form-label"><trans-text i18nKey="ui[8][16]"/></label>
            <div class="col-7">
              <input class="form-control transparent-input" type="text" v-model.trim="child_info_input[index].family_name" @change="$v.child_info_input.$each[index].family_name.$touch()">
            </div>
            <p class="col-12 pl-4 my-0 form-control-feedback">
              <input-feedback :validate-for-input="$v.child_info_input.$each[index].family_name" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['8'][11]"/></input-feedback>
            </p>

            <div class="col-12 form-hr">
              <hr class="">
            </div>
          </div>

          <!-- 入力項目-->
          <div class="form-group row" :class="{'has-danger': $v.child_info_input.$each[index].given_name.$error}">
            <label class="col-5 col-form-label"><trans-text i18nKey="ui[8][17]"/></label>
            <div class="col-7">
              <input class="form-control transparent-input" type="text" v-model.trim="child_info_input[index].given_name" @change="$v.child_info_input.$each[index].given_name.$touch()">
            </div>
            <p class="col-12 pl-4 my-0 form-control-feedback">
              <input-feedback :validate-for-input="$v.child_info_input.$each[index].given_name" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['8'][12]"/></input-feedback>
            </p>

            <div class="col-12 form-hr">
              <hr class="">
            </div>
          </div>

          <!-- 入力項目-->
          <div class="form-group row">
            <label class="col-5 col-form-label"><trans-text i18nKey="ui[8][18]"/></label>
            <div class="col-7">
              <p class="form-control-static">{{cartEvent.organization.name}}</p>
            </div>
            <div class="col-12 form-hr">
              <hr class="">
            </div>
          </div>

          <!-- 入力項目-->
          <div class="form-group row" :class="{'has-danger': $v.child_info_input.$each[index].group_name.$error}">
            <label class="col-5 col-form-label"><trans-text i18nKey="ui[8][20]"/></label>
            <div class="col-7">
              <input class="form-control transparent-input" type="text" v-model.trim="child_info_input[index].group_name" @change="$v.child_info_input.$each[index].group_name.$touch()">
            </div>
            <p class="col-12 pl-4 my-0 form-control-feedback">
              <input-feedback :validate-for-input="$v.child_info_input.$each[index].group_name" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['8'][13]"/></input-feedback>
            </p>

            <div class="col-12 form-hr">
              <hr class="">
            </div>
          </div>

          <!-- 入力項目-->
          <div class="form-group row" :class="{'has-danger': $v.child_info_input.$each[index].family_relation_id.$error}">
            <label class="col-5 col-form-label"><trans-text i18nKey="ui[8][21]"/></label>
            <div class="col-7">
              <select class="custom-select mb-2" v-model="child_info_input[index].family_relation_id" @change="$v.child_info_input.$each[index].family_relation_id.$touch()">
                <option :value="familyRelation.id" v-for="familyRelation in familyRelations">{{familyRelation.name}}</option>
              </select>

            </div>
            <p class="col-12 pl-4 my-0 form-control-feedback">
              <input-feedback :validate-for-input="$v.child_info_input.$each[index].family_relation_id" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['8'][14]"/></input-feedback>
            </p>

          </div>

        </div>
        <!--</template>-->
      </div>

    </div>




    <!-- フォーム送信UI -->
    <div class="row text-center" >
      <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
        <div class="my-4">
          <button type="button" class="btn w-100 btn-lg btn-warning" @click="tryForm" ><trans-text i18nKey="ui[8][22]" :adjustLangFontSizes="{}"/></button>
        </div>
      </div>
    </div>

    <!-- フォーム送信UI -->
    <div class="row text-center" >
      <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
        <div class="my-4">
          <!--<button type="button" class="btn w-100 btn-lg btn-default" ><trans-text i18nKey="ui[8][23]" :adjustLangFontSizes="{}"/></button>-->


          <router-link tag="button"class="btn w-100 btn-lg btn-default" :to="{ name: 'mypage::event::cart', query: {back_path:'/mypage/event/viewing'}, params: {} }" >
            <trans-text i18nKey="ui['8'][23]"/>
          </router-link>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  import FormPartialBase from 'extends/FormPartialBase.vue'
  import {required,email,minLength,alphaNum,sameAs} from 'systems/validators'

  export default {
    extends:FormPartialBase,
    components: {
    },
    props:["orderer","childInfos","cartEvents","familyRelations","storeData"],
    data () {
      return {
        defaultOrderer:{},
        isConfirm:false,
        input: {
          family_name:null,
          given_name:null,
          address_1:null,
          address_2:null,
          city:null,
          prefecture:null,
          zip_code:null,
          country_name:null,
          phone_nunber:null,
          email:null,
        },
        child_info_input:[],
      }
    },
    watch:{
      "storeData"(newVal,oldVal){
        if(!newVal){ return }
        this.input = newVal.input

        //dd("AA",newVal.child_info_input);

        this.child_info_input = app.make("_").map(this.cartEvents,(item)=>{
          let childInfo = app.make("_").find(newVal.child_info_input,(item2)=>{
              return item.id == item2.event_id
          })
//          dd("AAA1",childInfo)
          if(childInfo){
            let exitChildInfo = app.make("_").find(this.childInfos,(item2)=>{
              return childInfo.child_info_id == item2.id
            })
//            dd("AB",this.childInfos,"BB",exitChildInfo)
            if(!exitChildInfo){
              childInfo.child_info_id = -1
            }
          }

          return childInfo || {
              event_name: item.name,
              event_id: item.id,
              school_name: item.organization.name,
              child_info_id: -1,
              family_name: '',
              given_name: '',
              group_name: '',
              family_relation_id: 1,
            }
        })


//        this.child_info_input = app.make("_").map(newVal.child_info_input,(item)=>{
//            if(item.child_info_id != -1){
//                if(!app.make("_").find(this.childInfos,(childInfo)=>{
//                  return childInfo.id == item.child_info_id
//                })){
//                    return Object.assign(item,{child_info_id:-1})
//                }
//            }
//            return item
//        })
        //dd("BBB",this.child_info_input)

        //this.child_info_input = newVal.child_info_input
      },
      "orderer"(newVal, oldVal){
       //
       this.input = Object.assign({
          family_name:null,
          given_name:null,
          address_1:null,
          address_2:null,
          city:null,
          prefecture:null,
          zip_code:null,
          country_name:null,
          phone_nunber:null,
          email:null,
        },newVal)
      },
      "cartEvents"(newVal, oldVal){
        this.child_info_input = app.make("_").map(newVal, (item)=>{
          return {
            event_name:item.name,
            event_id:item.id,
            school_name:item.organization.name,
            child_info_id:-1,
            family_name:'',
            given_name:'',
            group_name:'',
            family_relation_id:'1',
          }
        })

//        this.child_info_input = app.make("_").times(newVal.length, ()=>{
//            return {
//              event_name:"",
//              event_id:"",
//              child_info_id:null,
//              family_name:'',
//              given_name:'',
//              group_name:'',
//              family_relation_id:'',
//            }
//        })
      },


      "input.zip_code"(newVal, oldVal){
        let val = String(newVal).replace(/[０-９]/g, function(s) {
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        }).replace(/[^\d]/g, '');
        this.input.zip_code =  val
      },
      "input.phone_nunber"(newVal, oldVal){
        let val = String(newVal).replace(/[０-９]/g, function(s) {
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        }).replace(/[^\d]/g, '');
        this.input.phone_nunber =  val
      },
    },
    validations: {
      child_info_input:{
        $each: {
          family_name: {
            required,
          },
          given_name: {
            required,
          },
          group_name: {
            required,
          },
          family_relation_id: {
            required,
          },
        }
      },
      input: {
        family_name: {
          required
        },
        given_name: {
          required
        },
        address_1: {
          required
        },
        address_2: {
        },
        city: {
          required
        },
        prefecture: {
          required
        },
        zip_code: {
          required
        },
        country_name: {
          required
        },
        phone_nunber: {
          required
        },
        email:{

        }
      }
    },
    created(){
    },
    mounted(){
    },
    methods:{
      applyChildInfo(childInfo,cartEventIndex,cartEvent){
        this.child_info_input.splice(cartEventIndex, 1, {
          event_name:cartEvent.name,
          event_id:cartEvent.id,
          school_name:cartEvent.organization.name,
          child_info_id:childInfo.id,
          family_name:childInfo.family_name,
          given_name:childInfo.given_name,
          group_name:childInfo.group_name,
          family_relation_id:childInfo.family_relation_id,
        })
        this.$v.child_info_input.$reset()
      },
      tryForm(e){

        //バリデーション
        if(this.$v.input.$invalid || this.$v.child_info_input.$each.$invalid){
          this.$v.input.$touch()
          this.$v.child_info_input.$each.$touch()
          return
        }

        let order_form = {
          input: this.input,
          child_info_input: this.child_info_input,
        }

        store.session({order_form})

        this.$router.push({ name: 'mypage::event::order_confirm', params: {} })

      },
    }
  }
</script>

<style lang="scss" scoped>
  .form-group{
    font-size: .9rem;
  }
  .content-header{
    background-color: #82ba1d;
    color:#fff;
  }

</style>



// WEBPACK FOOTER //
// PageForm.vue?273264be